<!--
 * @Description: 分账列表页面
 * @Author: wanqian, gaohc
 * @Date: 2022-09-29 16:43:52
-->
<template>
  <div class="body">
		<el-row style="margin: 25px 40px" :gutter="5" type="flex" justify="space-between" align="middle">
			<el-col :span="8" style="text-align: left">
				<span class="search-title">创建时间：</span>
        <el-date-picker v-model="createTimeRange" type="daterange" align="right" unlink-panels range-separator="至"
					start-placeholder="开始时间" end-placeholder="结束时间" :picker-options="dateRangePickerOptions"
					style="width: 240px" size="small" @change="changeCreateDatePicker">
				</el-date-picker>
			</el-col>
			<el-col :span="12" style="text-align: left">
				<div class="bk-time-tabs">
					<div :class="createTimeTabIndex == index ? 'search-tab search-tab-active mouse-pointer' 
						: 'search-tab search-tab-inactive mouse-pointer'"
						v-for="(item, index) in timeTabs" :key="index" @click="handleChangeCreateTimeTab(item, index)" >
						{{item.dateText}}
					</div>
				</div>
			</el-col>
			<el-col :span="4" style="text-align: right">
				<el-button size="small"  @click="handleQuery" 
					type="primary" icon="el-icon-search">
					搜 索
				</el-button>
			</el-col>
		</el-row>
		<el-row style="margin: 0 40px 25px 40px" :gutter="5" type="flex" justify="space-between" align="middle">
			<el-col :span="8" style="text-align: left">
				<span class="search-title">分账时间：</span>
        <el-date-picker v-model="sharingTimeRange" type="daterange" align="right" unlink-panels range-separator="至"
					start-placeholder="开始时间" end-placeholder="结束时间" :picker-options="dateRangePickerOptions"
					style="width: 240px" size="small" @change="changeSharingDatePicker">
				</el-date-picker>
			</el-col>
			<el-col :span="12" style="text-align: left">
				<div class="bk-time-tabs">
					<div :class="sharingTimeTabIndex == index ? 'search-tab search-tab-active mouse-pointer' 
						: 'search-tab search-tab-inactive mouse-pointer'"
						v-for="(item, index) in timeTabs" :key="item.index" @click="handleChangeSharingTimeTab(item, index)" >
						{{item.dateText}}
					</div>
				</div>
			</el-col>
			<el-col :span="4" style="text-align: left"></el-col>
		</el-row>
		<el-row style="margin: 0 40px 25px 40px" :gutter="5" type="flex" justify="space-between" align="middle">
			<el-col :span="8" style="text-align: left">
        <span class="search-title">机构名称：</span>
        <el-select size="small" style="width: 240px" v-model="filterParams.institutionId" filterable clearable 
					placeholder="请输入/选择" 
					:filter-method="interactionUtil.debounce((value) => commonUtil.handleListFilter(value, 'institutionList', srcInstitutionList, this))"
					@visible-change="(visible) => 
						commonUtil.handleListFilterVisibleChange(visible, 'institutionList', srcInstitutionList, this)">
          <el-option v-for="item in institutionList" :key="item.id" :label="item.name" :value="item.id" />
        </el-select>
      </el-col>
			<el-col :span="12" style="text-align: left">
        <span class="search-title">订单编号：</span>
				<el-input size="small" style="width: 240px" placeholder="请输入订单编号" v-model="filterParams.orderNo" 
					clearable>
				</el-input>
      </el-col>
			<el-col :span="4" style="text-align: left"></el-col>
		</el-row>
		<el-row style="margin: 0 40px 25px 40px" :gutter="5" type="flex" justify="space-between" align="middle">
			<el-col :span="8" style="text-align: left">
        <span class="search-title">服务人员：</span>
				<el-input size="small" style="width: 240px" placeholder="请输入姓名/手机号" 
					v-model="filterParams.servedPersonNameOrMobile" clearable>
				</el-input>
      </el-col>
			<el-col :span="12" style="text-align: left">
        <span class="search-title">分账状态：</span>
				<el-select size="small" style="width: 240px" v-model="filterParams.status" filterable clearable 
					placeholder="请输入/选择">
          <el-option v-for="(item, index) in sharingStatusList" 
						:key="index" :label="item.value" :value="parseInt(item.key)" />
        </el-select>
      </el-col>
			<el-col :span="4" style="text-align:right">
			</el-col>
		</el-row>
		<div class="main-line"></div>
		<el-table style="margin: 20px 40px; border: 1px solid #f0f0f0;" :style="tableWidth" ref="table" :data="dataTable" 
      header-cell-class-name="table-header-color" row-key="id">
			<el-table-column prop="institutionName" label="机构名称" min-width="15%" align="left"></el-table-column>
			<el-table-column label="订单编号" min-width="15%" align="left">
				<template slot-scope="scope">
					<span :class="scope.row.revenueSharing.orderNo == '' || !scope.row.revenueSharing.orderNo ? '' : 'mouse-pointer'"  
						:style="{color: scope.row.revenueSharing.orderNo == '' || !scope.row.revenueSharing.orderNo ? '#606266' : '#3E7EF5'}"
						@click="handleOrderDetailsClick(scope.row.revenueSharing.orderId)">
						{{scope.row.revenueSharing.orderNo == '' || !scope.row.revenueSharing.orderNo ? '- -' : scope.row.revenueSharing.orderNo}}
					</span>
				</template>	
			</el-table-column>
			<el-table-column label="应分总额（元）" min-width="15%" align="left">
				<template slot-scope="scope">
					<div style="font-size: 14px; color: #606266; line-height: 17px;">
						{{'¥' + scope.row.revenueSharing.sharableAmountYuan}}
					</div>
					<div style="margin-top: 4px; font-size: 12px; color: #606266; line-height: 17px;">
						{{'实付：' + scope.row.payAmountYuan + ' 退款：' + scope.row.refundAmountYuan}}
					</div>
				</template>
			</el-table-column>
			<el-table-column label="实分金额（元）" min-width="17%" align="left">
				<template slot-scope="scope">
					<el-popover v-if="scope.row.revenueSharing.sharingAmountYuan
						&& scope.row.realSharedAmountList.length" 
						placement="bottom" 
						width="136" trigger="hover">
						<div slot="reference" style="word-break: break-word;">
							<span v-for="(item, index) in scope.row.realSharedAmountList" :key="index">
								{{ item.amountYuan }}
								<span v-if="index != scope.row.realSharedAmountList.length - 1"> | </span>
							</span>
						</div>
						<div class="actual-money-popover">
							<div v-for="(i, idx) in scope.row.realSharedAmountList" :key="idx" >
								<span>{{ i.receiver }}</span>
								<span>：</span>
								<span>{{ i.amountYuan }}</span>
							</div>
						</div>
					</el-popover>
					<span v-else>- -</span>
				</template>
			</el-table-column>
			<el-table-column label="分账状态" min-width="8%" align="left">
				<template slot-scope="scope">
          <el-popover v-if="scope.row.revenueSharing.status == 3" placement="bottom" width="200" trigger="hover" ref="sharingFailPopover">
						<div slot="reference" class="mouse-pointer">
							<div class="text-status-fail">
								<span>{{scope.row.revenueSharing.statusText}}</span>
								<img class="img-question" src="@/assets/finance/sharinglist/icon-sharinglist-question-red.png" alt="" />
							</div>
            </div>
						<div>
							<div class="fail-reason-popover-content">
								<span>失败原因：</span>
								{{scope.row.revenueSharing.failReason ? scope.row.revenueSharing.failReason : '- -'}}
							</div>
							<div class="bk-transfer-accounts mouse-pointer" @click="handleResharing(scope.row)">
								<img src="@/assets/finance/sharinglist/icon-sharinglist-transfer-accounts.png" alt="" />
								<span>重分</span>
							</div>
						</div>
					</el-popover>
					<div v-else>{{scope.row.revenueSharing.statusText}}</div>
				</template>
			</el-table-column>
			<el-table-column label="申请人" min-width="10%" align="left">
				<template slot-scope="scope">
					{{scope.row.revenueSharing.applyForName ? scope.row.revenueSharing.applyForName : '- -'}}
				</template>
			</el-table-column>
			<el-table-column label="申请时间" min-width="12%" align="left">
				<template slot-scope="scope">
					{{scope.row.revenueSharing.applyForTime ? dateFormat(scope.row.revenueSharing.applyForTime) : '- -'}}
				</template>
			</el-table-column>
			<el-table-column label="操作" min-width="8%" align="left">
        <template slot-scope="scope">
					<el-button @click="handleListItemMenu(scope.row)" type="text" size="small" 
						v-if="scope.row.revenueSharing.status || (!scope.row.revenueSharing.status && dataPvgList.includes('INCOME_2_SHARE'))" >
						{{scope.row.revenueSharing.status ? '详情' : '申请分账'}}
					</el-button>
				</template>
			</el-table-column>
		</el-table>
		<el-row class="foot-pagination">
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurPage" 
      	:current-page="filterParams.page" :page-sizes="pageSizes" :page-size="filterParams.pageSize" 
      	layout="total, prev, pager, next, sizes, jumper" :total="totalNumber" />
    </el-row>
		<!-- 订单详情对话框 -->
		<order-details-dialog :visible="showOrderDialog" @check-collectdetails="handleSeeCollectDetails"
			@close-dialog="closeOrderDialog" :orderId="orderId" />
		<!-- 评估收款详情对话框 -->
		<payment-details-dialog :visible="showCollectMoneyDialog" @close-dialog="closePaymentDialog" :orderId="orderId" />
		<!-- 申请分账对话框 -->
		<apply-sharing-dialog :visible="showApplySharingDialog" :orderId="orderId" :sharingId="sharingId" 
			@close-dialog="closeApplySharingDialog" @check-order-detail="handleOrderDetailsClick" />
		<!-- 分账详情对话框 -->
		<sharing-details-dialog :visible="showSharingDetailsDialog" :orderId="orderId" :sharingId="sharingId" 
			@close-dialog="closeSharingDetailsDialog" @check-order-detail="handleOrderDetailsClick" />
			<!-- 分账申请提交成功对话框 -->
		<submit-sharing-dialog :visible="showSubmitSharingDialog" 
			:sharingSuccessData="sharingSuccessData" @close-dialog="closeSubmitSharingDialog" />
  </div>
</template>

<script>
import Constant from '@/global/Constant.js'
import OrderDetails from '../ordermng/components/OrderDetails.vue'
import PaymentDetails from '../ordermng/components/PaymentDetails.vue'
import ApplySharing from './components/sharinglist/ApplySharing.vue'
import SharingDetails from './components/sharinglist/SharingDetails.vue'
import SubmitSharing from './components/sharinglist/SubmitSharing.vue'

export default {
  name: 'SharingList',
	
  components: {
		'order-details-dialog': OrderDetails,
    'payment-details-dialog': PaymentDetails,
		'apply-sharing-dialog': ApplySharing,
		'sharing-details-dialog': SharingDetails,
		'submit-sharing-dialog': SubmitSharing,
  },

  data() {
    return {
		dataPvgList: [],    //在角色配置页面上的操作权限
		filterParams: {
			page: 1,
			pageSize: this.commonConst.PAGE_SIZE,
		},
		pageSizes: this.commonConst.PAGE_SIZES,
		createTimeRange: [],
		sharingTimeRange: [],
		dateRangePickerOptions: {
			disabledDate(time) {
				return time.getTime() > Date.now(); 
			}
		},
		timeTabs: [],
		createTimeTabIndex: 0,
		sharingTimeTabIndex: 0,
		institutionList: [],
		srcInstitutionList: [],
		filterSharingStatusList: [],
		sharingStatusList: [],
		dataTable: [],
		totalNumber: 0,

		orderId: '',
		sharingId: '',
		//以下是订单详情对话框使用
		showOrderDialog : false,

		// 以下是评估详情对话框使用
		showCollectMoneyDialog: false,

		// 以下是申请分账对话框使用
		showApplySharingDialog: false,

		// 以下是分账详情对话框使用
		showSharingDetailsDialog: false,

		// 以下是分账申请提交成功对话框使用
		sharingSuccessData: {},
		showSubmitSharingDialog: false,
    }
  },

	computed: {
    tableWidth() {
      return 'width:' + (this.$root.contentWidth - 80) + 'px';
    },
  },
  
  methods:{
	async initData() {
		await this.getDataPvg4CurRole();
		await this.getFilterDo();
		await this.listSharings();
    },

	getDataPvg4CurRole() {
		return new Promise((resolve) => {
			let requestData = {
			method: 'GET',
			url: this.commonUrl.URL_GET_DATA_PVG_4_CURROLE,
			param: {entityKey: 'INCOME'},
			};
			this.vueRequest(requestData).then(result => {
			if (result != null) {
				this.dataPvgList = result.data;
				resolve();
			}
			})
		})
    },

	getFilterDo() {
      return new Promise((resolve) => {
        this.appAxios("GET", Constant.URL_GET_REVENUE_SHARING_FILTER_DO).then(result => {
          if (result != null) {
						this.institutionList = result.data.simpleInstitutionList;
      			this.srcInstitutionList = result.data.simpleInstitutionList;
						this.timeTabs = result.data.dateFilterList;
						this.sharingStatusList = this.commonUtil.map2List(result.data.revenueSharingTypeMap);
            resolve();
          }
        })
      })
    },

		listSharings() {
			return new Promise((resolve) => {
        let [header, esParam] = this.encryptionUtil.encryptAndSignAllParams(this.filterParams,
          Constant.ENCRYPTION_KEY_NAME, Constant.ENCRYPTION_KEY,
          Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
        let requestData = {
          method: 'GET',
          url: Constant.URL_PAGE_REVENUE_SHARINGS,
          param: esParam,
          header: header,
          contentType: this.commonConst.CNTYPE_URLENCODED,
        };
        this.vueRequest(requestData).then((result) => {
          if (result != null) {
						this.dataTable = result.data;
            this.totalNumber = result.totalNumber;
            resolve();
          }
        })
      })
		},

		handleChangeCreateTimeTab(item, index) {
			this.createTimeTabIndex = index;
			this.buildTimeRangeByMode('createTime', item, index);
		},

		handleChangeSharingTimeTab(item, index) {
			this.sharingTimeTabIndex = index;
			this.buildTimeRangeByMode('sharingTime', item, index);
		},

		buildTimeRangeByMode(mode, item, index) {
			let timeRange = item.dateText == '全部' ? [] : [this.timeTabs[index].startDate, this.timeTabs[index].endDate];
			if (mode == 'createTime') {
				this.createTimeRange = timeRange;
			} else {
				this.sharingTimeRange = timeRange;
			}
		},

		changeCreateDatePicker(dateRange) {
			if (!dateRange) {return;}
			this.createTimeTabIndex = null;
		},

		changeSharingDatePicker(dateRange) {
			if (!dateRange) {return;}
			this.sharingTimeTabIndex = null;
		},

		handleQuery() {
      this.filterParams.page = 1;
			this.filterParams.begDate = this.createTimeRange && this.createTimeRange.length 
				? this.dateUtil.dateFormat(this.createTimeRange[0]) : '';
			this.filterParams.endDate = this.createTimeRange && this.createTimeRange.length
				? this.dateUtil.dateFormat(this.createTimeRange[1]) : '';
			this.filterParams.sharingBegDate = this.sharingTimeRange && this.sharingTimeRange.length 
				? this.dateUtil.dateFormat(this.sharingTimeRange[0]) : '';
			this.filterParams.sharingEndDate = this.sharingTimeRange && this.sharingTimeRange.length 
				? this.dateUtil.dateFormat(this.sharingTimeRange[1]) : '';
			this.filterParams.statusList = this.filterSharingStatusList.length ? this.filterSharingStatusList.join(",") : '';
      this.listSharings();
    },

		// 重分
		handleResharing(row) {
			this.showApplySharingDialog = true;
			this.sharingId = row.revenueSharing.id;
			this.orderId = row.revenueSharing.orderId;
		},

		handleOrderDetailsClick(orderId) {
			if (orderId == '' || !orderId) {return;}
			this.orderId = orderId;
			this.showOrderDialog = true;
		},

		//查看评估详情
		handleSeeCollectDetails() {
			this.showCollectMoneyDialog = true;
		},

		closeOrderDialog() {
			this.showOrderDialog = false;
		},

		//关闭评估收款详情对话框
		closePaymentDialog() {
			this.showCollectMoneyDialog = false;
		},

		handleListItemMenu(row) {
			this.orderId = row.revenueSharing.orderId;
				this.sharingId = row.revenueSharing.id;
			if (!row.revenueSharing.status) {
				this.showApplySharingDialog = true;
			} else {
				this.showSharingDetailsDialog = true;
			}
		},

		closeApplySharingDialog(refresh, sharingSuccessData) {
			this.showApplySharingDialog = false;
			if (refresh) {
				this.sharingSuccessData = sharingSuccessData;
				this.showSubmitSharingDialog = true;
				this.listSharings();
			}
		},

		closeSharingDetailsDialog(refresh) {
			this.showSharingDetailsDialog = false;
			if (refresh) {
				this.listSharings();
			}
		},

		closeSubmitSharingDialog() {
			this.showSubmitSharingDialog = false;
			this.showSharingDetailsDialog = true;
		},

		//以下是分页控件操作
    handleSizeChange(val) {
      this.filterParams.pageSize = val;
      this.listSharings();
    },

    handleCurPage(curPage) {
      this.filterParams.page = curPage;
      this.listSharings();
    },

		dateFormat(date) {
      return this.dateUtil.dateTimeFormat(date, "YYYY-MM-DD HH:mm");
    },
  },

  mounted() {
    this.$emit("breadcrumb", {text1: '财务管理',text2: '分账列表'});
		this.initData();
  }
}
</script>

<style scoped>
.body {
  margin: 0;
  text-align: center;
  border: solid 0px;
}
.search-title {
  color: #657180;
  font-size: 14px;
}
.main-line {
  height: 10px;
  background-color: #f2f3f4;
}
.bk-time-tabs {
	width: auto;
	display: flex;
	align-items: center;
	overflow: hidden;
}
.search-tab {
	text-align: center;
	width: 96px;
	height: 30px;
	line-height: 30px;
	font-size: 14px;
	border-top: 1px solid #D7DDE5;
	border-bottom: 1px solid #D7DDE5;
	border-left: 1px solid #D7DDE5;
}
.search-tab:first-child {
	border-top-left-radius: 5px;
	border-bottom-left-radius: 5px;
}
.search-tab:last-child {
	border-right: 1px solid #D7DDE5;
	border-top-right-radius: 5px;
	border-bottom-right-radius: 5px;
}
.search-tab-active {
	background-color: #3E7EF5;
	color: #FFFFFF;

}
.search-tab-inactive {
	background-color: white;
	color: #657180;
}
.actual-money-popover {
	font-size: 14px;
	color: #666666;
	line-height: 26px;
}
.foot-pagination {
  text-align: right;
  right: 40px;
  border: solid 0px;
}
.text-status-fail {
	display: flex;
	align-items: center;
	color: #FF4646;
}
.img-question {
	margin-left: 5px;
	width: 17px;
	height: 16px;
}
.fail-reason-popover-content {
	margin-top: 3px;
	font-size: 12px;
	color: #606266;
	line-height: 17px;
}
.bk-transfer-accounts {
	margin-top: 2px;
	display: flex;
	align-items: center;
	justify-content: flex-end;
	font-size: 12px;
	color: #3E7EF5;
	line-height: 17px;
}
.bk-transfer-accounts img {
	margin-right: 4px;
	width: 18px;
	height: 17px;
}
</style>


// WEBPACK FOOTER //
// src/components/finance/SharingList.vue